import React from "react";

const AdvancedManagementAboutIndication = ({ name, city } = props) => (
	<div className="advanced-management-cpf-search__cpf__participant-about">
		<strong className="advanced-management-cpf-search__cpf__participant-about--title">
			Participante encontrado.
		</strong>
		<div className="advanced-management-cpf-search__cpf__participant-about--info">
			<div>
				<div>Nome</div>
				<strong>{name}</strong>
			</div>
			<div>
				<div>Cidade</div>
				<strong>{city}</strong>
			</div>
		</div>
	</div>
);

export default AdvancedManagementAboutIndication;
